'use client';

import React, { useState } from 'react';

import Header from '@/components/Header';
import Footer from '@/components/Footer';

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const services = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-7 h-7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
      </svg>
    ),
    title: 'Recuperación de Inmuebles',
    desc: 'Actuamos con rapidez y eficacia para recuperar su propiedad ocupada, aplicando los procedimientos legales más ágiles disponibles.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-7 h-7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
      </svg>
    ),
    title: 'Mediación con Ocupantes',
    desc: 'Gestionamos la comunicación y negociación con los ocupantes de forma profesional, buscando soluciones rápidas y sin conflictos innecesarios.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-7 h-7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: 'Protección de Propiedades',
    desc: 'Implementamos medidas preventivas para proteger inmuebles vacíos o en riesgo, evitando ocupaciones antes de que se produzcan.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-7 h-7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z" />
      </svg>
    ),
    title: 'Vigilancia y Cámaras',
    desc: 'Instalación y monitorización de sistemas de vigilancia para propiedades urbanas y terrenos rústicos en Mallorca, con cobertura 24/7.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" className="w-7 h-7">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
      </svg>
    ),
    title: 'Asesoría Jurídica Propia',
    desc: 'Contamos con asesoría jurídica integrada especializada en derecho inmobiliario, ofreciendo una solución completa sin intermediarios.',
  },
];

const stats = [
  { value: '+95', label: 'Casos resueltos' },
  { value: '24h', label: 'Tiempo de respuesta' },
  { value: '100%', label: 'Cobertura legal' },
];

const processSteps = [
  {
    icon: '📋',
    step: 'Paso 01',
    title: 'Evaluación Inicial',
    desc: 'Analizamos su caso de forma gratuita y sin compromiso. En menos de 24 horas tendrá una valoración clara de las opciones disponibles.',
    tag: 'Gratuita · Sin compromiso',
  },
  {
    icon: '⚖️',
    step: 'Paso 02',
    title: 'Estrategia Jurídica',
    desc: 'Nuestros abogados especializados diseñan la estrategia legal más eficaz para su situación concreta, maximizando las posibilidades de éxito.',
    tag: 'Asesoría especializada',
  },
  {
    icon: '🛡️',
    step: 'Paso 03',
    title: 'Actuación Coordinada',
    desc: 'Coordinamos todos los recursos operativos y legales necesarios para ejecutar la recuperación del inmueble con la máxima eficacia y seguridad.',
    tag: 'Operativa + Legal',
  },
  {
    icon: '🏠',
    step: 'Paso 04',
    title: 'Recuperación del Inmueble',
    desc: 'Recuperamos su propiedad dentro del marco legal vigente, con plena documentación del proceso y acompañamiento hasta la entrega de llaves.',
    tag: 'Resultado garantizado',
  },
];

const comparisonRows = [
  { label: 'Objetivo principal', others: 'Negociación sin respaldo legal', gestra: 'Recuperación efectiva dentro del marco legal' },
  { label: 'Capacidad operativa', others: 'Solo asesoría o solo gestión', gestra: 'Equipo operativo y jurídico integrado' },
  { label: 'Tiempo de respuesta', others: 'Días o semanas para actuar', gestra: 'Evaluación en 24h, actuación inmediata' },
  { label: 'Transparencia de costes', others: 'Honorarios variables y poco claros', gestra: 'Tarifa fija acordada antes de actuar' },
  { label: 'Cobertura legal', others: 'Actuaciones al margen de la ley', gestra: 'Siempre dentro del ordenamiento jurídico vigente' },
  { label: 'Seguimiento del caso', others: 'Atención puntual sin continuidad', gestra: 'Acompañamiento completo hasta la resolución' },
];

const pricingItems = [
  {
    tag: 'Tarifa fija',
    title: 'Evaluación del caso',
    amount: 'Consulta gratuita',
    desc: 'Analizamos la situación de su inmueble, identificamos la estrategia más adecuada y le entregamos un informe detallado con las opciones disponibles. Sin compromisos ni costes ocultos.',
  },
  {
    tag: 'Tarifa fija',
    title: 'Intervención operativa',
    amount: 'Presupuesto por caso',
    desc: 'Actuación directa para la recuperación del inmueble dentro del marco legal vigente. El alcance se define según la evaluación previa. Sin sorpresas en la factura.',
  },
  {
    tag: 'Tarifa fija',
    title: 'Gestión integral',
    amount: 'Presupuesto por caso',
    desc: 'Desde la evaluación inicial hasta la recuperación total del inmueble, incluyendo asesoría jurídica, gestión operativa y seguimiento completo del proceso.',
  },
];

const cases = [
  {
    tag: 'Vivienda residencial',
    location: 'Palma de Mallorca, Islas Baleares',
    result: 'Recuperación en 36 horas',
    title: 'Desokupación express en menos de 48 horas',
    desc: 'El propietario detectó la ocupación de su vivienda vacacional un viernes por la tarde. Contactó con Gestra Antiokupa esa misma noche. Tras evaluar la situación y coordinar con las autoridades competentes, el inmueble fue recuperado el domingo por la mañana, antes de que la ocupación se consolidara.',
    status: 'Propiedad recuperada',
  },
  {
    tag: 'Local comercial',
    location: 'Calvià, Mallorca',
    result: 'Recuperación en 12 días',
    title: 'Recuperación de local comercial ocupado por organización',
    desc: 'Un local comercial en Calvià fue ocupado por un grupo organizado. El propietario llevaba tres semanas intentando resolverlo sin éxito. Gestra Antiokupa diseñó una estrategia jurídica y operativa coordinada que permitió recuperar el local en menos de dos semanas, con plena cobertura legal.',
    status: 'Propiedad recuperada',
  },
  {
    tag: 'Arrendamiento residencial',
    location: 'Inca, Mallorca',
    result: 'Inmueble recuperado en 3 meses',
    title: 'Resolución de impago de alquiler con mínimo impacto',
    desc: 'Un propietario llevaba seis meses sin cobrar el alquiler de su piso. El inquilino se negaba a abandonar el inmueble. Gestra Antiokupa gestionó el proceso judicial de desahucio de principio a fin, logrando la recuperación del inmueble en el plazo mínimo posible y minimizando el impacto económico para el propietario.',
    status: 'Desahucio ejecutado',
  },
];

/* ─────────────────────────────────────────────
   CONTACT FORM
───────────────────────────────────────────── */
function ContactForm() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch('https://formsubmit.co/ajax/Info@gestraantiokupa.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          name: form.name,
          phone: form.phone,
          email: form.email,
          message: form.message,
          _subject: 'Nueva solicitud de evaluación — Gestra Antiokupa',
        }),
      });
      if (res.ok) {
        setStatus('sent');
        setForm({ name: '', phone: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  const inputStyle = {
    background: 'rgba(247,243,236,0.06)',
    border: '1px solid rgba(196,180,154,0.25)',
    color: '#F7F3EC',
    padding: '12px 16px',
    fontSize: '13px',
    fontFamily: 'Montserrat, sans-serif',
    outline: 'none',
    width: '100%',
    transition: 'border-color 0.2s ease',
  };

  const labelStyle = {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '9px',
    fontWeight: 600,
    letterSpacing: '0.25em',
    textTransform: 'uppercase' as const,
    color: '#C4B49A',
    display: 'block',
    marginBottom: '8px',
  };

  if (status === 'sent') {
    return (
      <div className="flex flex-col items-center justify-center py-16 gap-6 text-center">
        <div className="w-14 h-14 flex items-center justify-center" style={{ border: '1px solid #C4B49A' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#C4B49A" strokeWidth="1.5" className="w-7 h-7">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <h3 className="text-2xl" style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 400, letterSpacing: '0.05em', color: '#F7F3EC' }}>
          Solicitud recibida
        </h3>
        <p style={{ color: 'rgba(247,243,236,0.5)', fontFamily: 'Montserrat, sans-serif', fontSize: '13px', maxWidth: '320px', lineHeight: 1.7 }}>
          Hemos recibido su consulta. Nuestro equipo se pondrá en contacto con usted en las próximas horas.
        </p>
        <button
          onClick={() => setStatus('idle')}
          className="mt-4 px-8 py-3 text-xs font-semibold tracking-widest uppercase transition-all duration-200"
          style={{ border: '1px solid rgba(196,180,154,0.3)', color: '#C4B49A', fontFamily: 'Montserrat, sans-serif', background: 'transparent' }}
        >
          Enviar otra consulta
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label style={labelStyle}>Nombre *</label>
          <input type="text" name="name" value={form.name} onChange={handleChange} required placeholder="Su nombre completo" style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Teléfono *</label>
          <input type="tel" name="phone" value={form.phone} onChange={handleChange} required placeholder="+34 600 000 000" style={inputStyle} />
        </div>
      </div>
      <div>
        <label style={labelStyle}>Email *</label>
        <input type="email" name="email" value={form.email} onChange={handleChange} required placeholder="su@email.com" style={inputStyle} />
      </div>
      <div>
        <label style={labelStyle}>Descripción del caso *</label>
        <textarea name="message" value={form.message} onChange={handleChange} required rows={5} placeholder="Describa brevemente su situación..." style={{ ...inputStyle, resize: 'none' }} />
      </div>
      {status === 'error' && (
        <p style={{ color: '#e57373', fontSize: '12px', fontFamily: 'Montserrat, sans-serif' }}>Ha ocurrido un error. Por favor, inténtelo de nuevo o contáctenos directamente.</p>
      )}
      <button
        type="submit"
        disabled={status === 'sending'}
        className="mt-2 px-8 py-4 text-xs font-bold tracking-widest uppercase transition-all duration-200 disabled:opacity-50"
        style={{ background: '#C4B49A', color: '#1A1714', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em' }}
      >
        {status === 'sending' ? 'Enviando...' : 'Solicitar Evaluación Gratuita'}
      </button>
    </form>
  );
}

/* ─────────────────────────────────────────────
   PAGE
───────────────────────────────────────────── */
export default function HomePage() {
  const heroPhoto = '/assets/images/1221-1774970637313.png';
  const teamPhoto = '/assets/images/hf_20260317_090744_885efd2a-e6ce-4ce7-bdf2-c465332152c1-1774947072010.jpeg';

  return (
    <>
      <Header />

      <main style={{ fontFamily: 'Montserrat, sans-serif' }}>

        {/* ── HERO ── */}
        <section
          className="relative min-h-screen flex items-center justify-center overflow-hidden"
          style={{
            backgroundImage: `url('${heroPhoto}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(18,14,10,0.78) 0%, rgba(18,14,10,0.60) 45%, rgba(18,14,10,0.88) 100%)' }} />
          <div className="absolute inset-x-0 bottom-0 h-72" style={{ background: 'linear-gradient(to top, rgba(18,14,10,0.95), transparent)' }} />
          <div className="absolute inset-y-0 left-0 w-32" style={{ background: 'linear-gradient(to right, rgba(18,14,10,0.4), transparent)' }} />
          <div className="absolute inset-y-0 right-0 w-32" style={{ background: 'linear-gradient(to left, rgba(18,14,10,0.4), transparent)' }} />

          <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col items-center gap-8">
            <div className="flex items-center gap-4">
              <div style={{ width: '48px', height: '1px', background: 'linear-gradient(to right, transparent, rgba(196,180,154,0.7))' }} />
              <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#C4B49A', opacity: 0.8 }} />
              <div style={{ width: '48px', height: '1px', background: 'linear-gradient(to left, transparent, rgba(196,180,154,0.7))' }} />
            </div>

            <div className="flex flex-col items-center gap-0">
              <h1
                style={{
                  fontFamily: 'Cormorant Garamond, serif',
                  fontSize: 'clamp(2.6rem, 5.5vw, 5.2rem)',
                  fontWeight: 400,
                  letterSpacing: '0.025em',
                  lineHeight: 1.12,
                  color: '#F7F3EC',
                  textAlign: 'center',
                }}
              >
                Proteger la propiedad es un derecho
                <span style={{ color: '#C4B49A', margin: '0 0.18em' }}>—</span>
                <em style={{ fontStyle: 'italic', color: 'rgba(247,243,236,0.88)' }}>defenderla</em>
                <br />
                <em style={{ fontStyle: 'italic', color: '#C4B49A' }}>requiere experiencia.</em>
              </h1>
            </div>

            <div className="flex items-center gap-4">
              <div style={{ width: '32px', height: '1px', background: 'rgba(196,180,154,0.4)' }} />
              <div style={{ width: '3px', height: '3px', borderRadius: '50%', background: 'rgba(196,180,154,0.6)' }} />
              <div style={{ width: '32px', height: '1px', background: 'rgba(196,180,154,0.4)' }} />
            </div>

            <p style={{ color: 'rgba(247,243,236,0.55)', fontSize: '13px', maxWidth: '500px', lineHeight: 1.85, fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.04em' }}>
              Especialistas en recuperación de inmuebles ocupados y protección de la propiedad privada en Mallorca.
              Actuación rápida, discreta y con resultados demostrados.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
              <a
                href="#contacto"
                className="px-9 py-4 text-xs font-semibold tracking-widest uppercase transition-all duration-300"
                style={{ background: '#C4B49A', color: '#1A1714', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = '#D8CCBB'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = '#C4B49A'; }}
              >
                Solicitar evaluación del caso
              </a>
              <a
                href="#servicios"
                className="px-9 py-4 text-xs font-medium tracking-widest uppercase transition-all duration-300"
                style={{ border: '1px solid rgba(196,180,154,0.45)', color: 'rgba(247,243,236,0.85)', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15em' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(196,180,154,0.8)'; (e.currentTarget as HTMLElement).style.color = '#F7F3EC'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(196,180,154,0.45)'; (e.currentTarget as HTMLElement).style.color = 'rgba(247,243,236,0.85)'; }}
              >
                Conoce tus opciones
              </a>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-6 mt-4 pt-6 w-full justify-center" style={{ borderTop: '1px solid rgba(196,180,154,0.15)' }}>
              <a
                href="https://wa.me/34634941415"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 transition-colors duration-200"
                style={{ color: 'rgba(247,243,236,0.5)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
              >
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" style={{ color: '#C4B49A' }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                +34 634 94 14 15
              </a>
              <span className="hidden sm:block" style={{ color: 'rgba(196,180,154,0.3)' }}>·</span>
              <a
                href="mailto:Info@gestraantiokupa.com"
                className="flex items-center gap-2 transition-colors duration-200"
                style={{ color: 'rgba(247,243,236,0.5)', fontFamily: 'Montserrat, sans-serif', fontSize: '12px' }}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4" style={{ color: '#C4B49A' }}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
                Info@gestraantiokupa.com
              </a>
            </div>
          </div>
        </section>

        {/* ── ACERCA DE NOSOTROS ── */}
        <section id="nosotros" className="py-28" style={{ background: '#F7F3EC' }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-start">
              {/* Left — text */}
              <div className="flex flex-col gap-8">
                <div>
                  <span className="section-label block mb-5">Acerca de nosotros</span>
                  <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
                  <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 400, color: '#2A2520', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                    Especialistas en recuperación
                    <br />
                    <em style={{ color: '#7A7268', fontStyle: 'italic' }}>de inmuebles en Mallorca</em>
                  </h2>
                </div>
                <p style={{ color: '#7A7268', fontSize: '14px', lineHeight: 1.9, fontFamily: 'Montserrat, sans-serif' }}>
                  En Gestra Antiokupa somos una empresa especializada en la recuperación de inmuebles ocupados y en la protección de la propiedad privada. Contamos con una estructura operativa sólida y con asesoría jurídica propia, lo que nos permite ofrecer un servicio integral, eficaz y plenamente ajustado al marco legal vigente.
                </p>
                <p style={{ color: '#7A7268', fontSize: '14px', lineHeight: 1.9, fontFamily: 'Montserrat, sans-serif' }}>
                  Nuestro equipo está formado por profesionales con experiencia en la gestión de situaciones complejas, actuando siempre con discreción, responsabilidad y un alto compromiso con cada caso. Entendemos que cada situación es única, por lo que analizamos cada intervención de forma individual para aplicar la estrategia más adecuada.
                </p>
                {/* Case highlight */}
                <div className="p-8 flex flex-col gap-4" style={{ background: '#EDE6D8', borderLeft: '3px solid #C4B49A' }}>
                  <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 700, letterSpacing: '0.3em', textTransform: 'uppercase', color: '#C4B49A' }}>CASO RESUELTO</span>
                  <h4 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.3rem', fontWeight: 500, color: '#2A2520' }}>Recuperación de vivienda ocupada</h4>
                  <p style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '11px', color: '#7A7268', letterSpacing: '0.08em' }}>Intervención operativa y jurídica · Resolución eficaz</p>
                  <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.8, fontFamily: 'Montserrat, sans-serif' }}>
                    Tras la ocupación del inmueble, su valor de mercado se vio reducido en más de un 40%, generando una pérdida significativa para el propietario. Tras la intervención, se logró recuperar la propiedad dentro del marco legal, restableciendo su valor y devolviendo al propietario el control total de su inversión.
                  </p>
                </div>
              </div>

              {/* Right — stats + team */}
              <div className="flex flex-col gap-8">
                {/* Stats */}
                <div className="grid grid-cols-3 gap-px" style={{ background: 'rgba(196,180,154,0.25)' }}>
                  {stats.map((s, i) => (
                    <div key={i} className="flex flex-col items-center justify-center py-10 gap-2" style={{ background: '#F9F6F0' }}>
                      <span style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 3.5vw, 2.8rem)', fontWeight: 400, color: '#2A2520', letterSpacing: '-0.01em' }}>{s.value}</span>
                      <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#C4B49A', textAlign: 'center' }}>{s.label}</span>
                    </div>
                  ))}
                </div>

                {/* Team block */}
                <div className="p-8 flex flex-col gap-5" style={{ background: '#EDE6D8' }}>
                  <div>
                    <span className="section-label block mb-3">Nuestro Equipo</span>
                    <h3 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.5rem', fontWeight: 400, color: '#2A2520', letterSpacing: '0.02em' }}>
                      Profesionales con experiencia real sobre el terreno
                    </h3>
                  </div>
                  <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.85, fontFamily: 'Montserrat, sans-serif' }}>
                    Nuestro equipo combina capacidad operativa y conocimiento jurídico para actuar con rapidez, discreción y plena cobertura legal en cada intervención.
                  </p>
                  <div className="pt-4" style={{ borderTop: '1px solid rgba(196,180,154,0.3)' }}>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.7)' }}>
                      Gestra Antiokupa · Equipo Operativo
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── SERVICES ── */}
        <section id="servicios" className="py-28" style={{ background: '#F2EDE3' }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="mb-16">
              <span className="section-label block mb-5">Nuestros servicios</span>
              <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontWeight: 400, color: '#2A2520', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                Soluciones integrales para
                <br />
                <em style={{ color: '#7A7268', fontStyle: 'italic' }}>la protección de su patrimonio</em>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: 'rgba(196,180,154,0.2)' }}>
              {services.map((s, i) => (
                <div
                  key={i}
                  className={`gold-card p-10 flex flex-col gap-5 group ${i === 0 ? 'lg:col-span-2' : ''}`}
                  style={{ background: '#F7F3EC' }}
                >
                  <div style={{ color: '#C4B49A', opacity: 0.7 }} className="group-hover:opacity-100 transition-opacity duration-300">
                    {s.icon}
                  </div>
                  <h3 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.35rem', fontWeight: 500, color: '#2A2520', letterSpacing: '0.02em' }}>{s.title}</h3>
                  <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.8, fontFamily: 'Montserrat, sans-serif' }}>{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── PROCESS — 4 steps ── */}
        <section id="proceso" className="py-28" style={{ background: '#F7F3EC' }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="mb-16">
              <span className="section-label block mb-5">Cómo trabajamos</span>
              <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontWeight: 400, color: '#2A2520', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                Cómo Recuperamos
                <br />
                <em style={{ color: '#7A7268', fontStyle: 'italic' }}>Su Propiedad</em>
              </h2>
              <p className="mt-6" style={{ color: '#7A7268', fontSize: '14px', lineHeight: 1.85, maxWidth: '600px', fontFamily: 'Montserrat, sans-serif' }}>
                Nuestro método combina rigor jurídico con capacidad operativa real. Cada caso sigue un protocolo claro, diseñado para maximizar la eficacia y minimizar el tiempo de resolución.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px" style={{ background: 'rgba(196,180,154,0.25)' }}>
              {processSteps.map((p, i) => (
                <div key={i} className="p-10 flex flex-col gap-5" style={{ background: '#F9F6F0' }}>
                  <div className="flex items-center justify-between">
                    <span style={{ fontSize: '1.8rem' }}>{p.icon}</span>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#C4B49A' }}>{p.step}</span>
                  </div>
                  <h3 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.4rem', fontWeight: 400, color: '#2A2520', letterSpacing: '0.02em' }}>{p.title}</h3>
                  <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.8, fontFamily: 'Montserrat, sans-serif', flex: 1 }}>{p.desc}</p>
                  <div className="pt-4" style={{ borderTop: '1px solid rgba(196,180,154,0.3)' }}>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.7)' }}>{p.tag}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA strip */}
            <div className="mt-12 p-8 flex flex-col sm:flex-row items-center justify-between gap-6" style={{ background: '#EDE6D8', border: '1px solid rgba(196,180,154,0.3)' }}>
              <div>
                <p style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.4rem', fontWeight: 400, color: '#2A2520' }}>Respuesta en menos de 24 horas</p>
                <p style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '12px', color: '#7A7268', marginTop: '4px' }}>Cuéntenos su situación y le daremos una respuesta clara y directa.</p>
              </div>
              <a
                href="#contacto"
                className="shrink-0 px-8 py-4 text-xs font-semibold tracking-widest uppercase transition-all duration-300"
                style={{ background: '#C4B49A', color: '#1A1714', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = '#D8CCBB'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = '#C4B49A'; }}
              >
                Solicitar evaluación urgente
              </a>
            </div>
          </div>
        </section>

        {/* ── WHY US — comparison table ── */}
        <section
          id="por-que"
          className="py-28 relative overflow-hidden"
          style={{
            backgroundImage: `url('${teamPhoto}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
          }}
        >
          <div className="absolute inset-0" style={{ background: 'rgba(18,14,10,0.93)' }} />
          <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(to right, transparent, #C4B49A, transparent)' }} />

          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="mb-16">
              <span className="block mb-5" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.7)' }}>Por qué elegirnos</span>
              <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontWeight: 400, color: '#F7F3EC', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                ¿Por Qué Elegir
                <br />
                <em style={{ color: '#C4B49A', fontStyle: 'italic' }}>Gestra Antiokupa?</em>
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
              {/* Left — text */}
              <div className="flex flex-col gap-6">
                <p style={{ color: 'rgba(247,243,236,0.65)', fontSize: '14px', lineHeight: 1.9, fontFamily: 'Montserrat, sans-serif' }}>
                  Recuperar un inmueble ocupado requiere algo más que buenas intenciones: necesita un equipo con experiencia real, capacidad operativa y conocimiento jurídico. En Gestra Antiokupa combinamos los tres elementos para ofrecer un servicio integral que otros no pueden igualar.
                </p>
                <p style={{ color: 'rgba(247,243,236,0.65)', fontSize: '14px', lineHeight: 1.9, fontFamily: 'Montserrat, sans-serif' }}>
                  No improvisamos. Cada caso se analiza de forma individual, se diseña una estrategia específica y se ejecuta con precisión. Actuamos siempre dentro de la legalidad, con discreción y con un único objetivo: devolver su propiedad a sus manos.
                </p>
                <blockquote className="mt-2 p-6 flex flex-col gap-3" style={{ borderLeft: '2px solid #C4B49A', background: 'rgba(196,180,154,0.06)' }}>
                  <p style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.2rem', fontStyle: 'italic', color: '#F7F3EC', lineHeight: 1.6 }}>
                    "La propiedad privada es un derecho fundamental. Defenderla es nuestra razón de ser."
                  </p>
                  <cite style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.6)', fontStyle: 'normal' }}>
                    Principio fundacional — Gestra Antiokupa
                  </cite>
                </blockquote>
                <a
                  href="#casos"
                  className="inline-flex items-center gap-2 mt-2 text-xs font-semibold tracking-widest uppercase transition-colors duration-200"
                  style={{ color: '#C4B49A', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15em' }}
                >
                  Ver casos resueltos →
                </a>
              </div>

              {/* Right — comparison table */}
              <div className="overflow-hidden" style={{ border: '1px solid rgba(196,180,154,0.2)' }}>
                {/* Header row */}
                <div className="grid grid-cols-3" style={{ background: 'rgba(196,180,154,0.1)', borderBottom: '1px solid rgba(196,180,154,0.2)' }}>
                  <div className="p-4 col-span-1" />
                  <div className="p-4 text-center" style={{ borderLeft: '1px solid rgba(196,180,154,0.15)' }}>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(247,243,236,0.4)' }}>Otras opciones</span>
                  </div>
                  <div className="p-4 text-center" style={{ borderLeft: '1px solid rgba(196,180,154,0.15)', background: 'rgba(196,180,154,0.08)' }}>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#C4B49A' }}>Gestra Antiokupa</span>
                  </div>
                </div>
                {comparisonRows.map((row, i) => (
                  <div
                    key={i}
                    className="grid grid-cols-3"
                    style={{ borderBottom: i < comparisonRows.length - 1 ? '1px solid rgba(196,180,154,0.12)' : 'none' }}
                  >
                    <div className="p-4">
                      <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(247,243,236,0.5)' }}>{row.label}</span>
                    </div>
                    <div className="p-4" style={{ borderLeft: '1px solid rgba(196,180,154,0.12)' }}>
                      <p style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '11px', color: 'rgba(247,243,236,0.35)', lineHeight: 1.6 }}>{row.others}</p>
                    </div>
                    <div className="p-4" style={{ borderLeft: '1px solid rgba(196,180,154,0.12)', background: 'rgba(196,180,154,0.04)' }}>
                      <p style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '11px', color: 'rgba(247,243,236,0.8)', lineHeight: 1.6 }}>{row.gestra}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── PRICING ── */}
        <section id="precios" className="py-28" style={{ background: '#F2EDE3' }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="mb-16">
              <span className="section-label block mb-5">Tarifas</span>
              <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontWeight: 400, color: '#2A2520', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                ¿Cuánto Cuesta
                <br />
                <em style={{ color: '#7A7268', fontStyle: 'italic' }}>el Servicio?</em>
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
              {/* Left — text */}
              <div className="flex flex-col gap-6">
                <p style={{ color: '#7A7268', fontSize: '14px', lineHeight: 1.9, fontFamily: 'Montserrat, sans-serif' }}>
                  En Gestra Antiokupa trabajamos con tarifas fijas y transparentes, acordadas antes de iniciar cualquier actuación. No existen costes ocultos ni sorpresas: usted sabe exactamente lo que va a pagar desde el primer momento.
                </p>
                <p style={{ color: '#7A7268', fontSize: '14px', lineHeight: 1.9, fontFamily: 'Montserrat, sans-serif' }}>
                  La evaluación inicial es el punto de partida. Analizamos su caso sin compromiso y le informamos de las opciones disponibles, los plazos estimados y el coste total del servicio. Si no podemos ayudarle, se lo decimos claramente.
                </p>
                <blockquote className="mt-2 p-6 flex flex-col gap-3" style={{ borderLeft: '2px solid #C4B49A', background: '#EDE6D8' }}>
                  <p style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.15rem', fontStyle: 'italic', color: '#2A2520', lineHeight: 1.6 }}>
                    "La mejor inversión es recuperar su propiedad cuanto antes. Cada día de ocupación genera pérdidas."
                  </p>
                  <cite style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.8)', fontStyle: 'normal' }}>
                    Principio de actuación — Gestra Antiokupa
                  </cite>
                </blockquote>
                <a
                  href="#contacto"
                  className="inline-flex items-center justify-center px-8 py-4 text-xs font-semibold tracking-widest uppercase transition-all duration-300 mt-2"
                  style={{ background: '#C4B49A', color: '#1A1714', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em' }}
                  onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = '#D8CCBB'; }}
                  onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = '#C4B49A'; }}
                >
                  Solicitar evaluación gratuita
                </a>
              </div>

              {/* Right — pricing cards */}
              <div className="flex flex-col gap-4">
                {pricingItems.map((item, i) => (
                  <div
                    key={i}
                    className="p-8 flex flex-col gap-4 relative overflow-hidden"
                    style={{ background: '#F9F6F0', border: '1px solid rgba(196,180,154,0.2)' }}
                  >
                    <div className="absolute left-0 top-0 bottom-0 w-0.5" style={{ background: i === 0 ? '#C4B49A' : 'transparent' }} />
                    <div className="flex items-start justify-between gap-4">
                      <div>
                        <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 700, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#C4B49A' }}>{item.tag}</span>
                        <h3 className="mt-1" style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.35rem', fontWeight: 500, color: '#2A2520', letterSpacing: '0.02em' }}>{item.title}</h3>
                      </div>
                      <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '12px', fontWeight: 600, color: '#2A2520', whiteSpace: 'nowrap', paddingTop: '4px' }}>{item.amount}</span>
                    </div>
                    <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.8, fontFamily: 'Montserrat, sans-serif' }}>{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── REAL CASES ── */}
        <section id="casos" className="py-28" style={{ background: '#EDE6D8' }}>
          <div className="max-w-7xl mx-auto px-6">
            <div className="mb-16">
              <span className="section-label block mb-5">Casos resueltos</span>
              <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
              <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontWeight: 400, color: '#2A2520', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                Resultados que
                <br />
                <em style={{ color: '#7A7268', fontStyle: 'italic' }}>hablan por sí solos</em>
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-px" style={{ background: 'rgba(196,180,154,0.3)' }}>
              {cases.map((c, i) => (
                <div key={i} className="gold-card p-10 flex flex-col gap-5" style={{ background: '#EDE6D8' }}>
                  <div className="flex flex-col gap-1">
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 600, letterSpacing: '0.25em', textTransform: 'uppercase', color: '#C4B49A' }}>
                      {c.tag}
                    </span>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', color: '#7A7268', letterSpacing: '0.08em' }}>
                      {c.location}
                    </span>
                  </div>
                  <div>
                    <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '9px', fontWeight: 600, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.7)' }}>{c.result}</span>
                    <h3 className="mt-2" style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.35rem', fontWeight: 500, color: '#2A2520', letterSpacing: '0.02em' }}>{c.title}</h3>
                  </div>
                  <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.8, fontFamily: 'Montserrat, sans-serif', flex: 1 }}>{c.desc}</p>
                  <div className="mt-auto pt-5" style={{ borderTop: '1px solid rgba(196,180,154,0.3)' }}>
                    <span style={{ color: '#C4B49A', fontSize: '10px', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15em', textTransform: 'uppercase' }}>{c.status}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA strip */}
            <div className="mt-12 p-10 flex flex-col items-center gap-5 text-center" style={{ background: '#F2EDE3', border: '1px solid rgba(196,180,154,0.25)' }}>
              <span className="section-label">El siguiente paso</span>
              <h3 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', fontWeight: 400, color: '#2A2520', letterSpacing: '0.02em' }}>
                Ya hemos resuelto casos como el suyo. La clave está en actuar a tiempo.
              </h3>
              <p style={{ color: '#7A7268', fontSize: '13px', lineHeight: 1.85, maxWidth: '520px', fontFamily: 'Montserrat, sans-serif' }}>
                La evaluación inicial es gratuita y sin compromiso. Analizamos su situación, le explicamos las opciones disponibles y le damos una respuesta clara. Sin rodeos.
              </p>
              <a
                href="#contacto"
                className="mt-2 px-9 py-4 text-xs font-semibold tracking-widest uppercase transition-all duration-300"
                style={{ background: '#C4B49A', color: '#1A1714', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.18em' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = '#D8CCBB'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = '#C4B49A'; }}
              >
                Solicitar evaluación gratuita
              </a>
            </div>
          </div>
        </section>

        {/* ── CONTACT ── */}
        <section
          id="contacto"
          className="py-28 relative overflow-hidden"
          style={{
            backgroundImage: `url('${heroPhoto}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center top',
            backgroundAttachment: 'fixed',
          }}
        >
          <div className="absolute inset-0" style={{ background: 'rgba(18,14,10,0.93)' }} />
          <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(to right, transparent, #C4B49A, transparent)' }} />

          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-start">
              {/* Left */}
              <div className="flex flex-col gap-8">
                <div>
                  <span className="block mb-5" style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '10px', fontWeight: 600, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'rgba(196,180,154,0.7)' }}>Contacto</span>
                  <div style={{ width: '40px', height: '1px', background: '#C4B49A', marginBottom: '24px' }} />
                  <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem, 4vw, 3.5rem)', fontWeight: 400, color: '#F7F3EC', lineHeight: 1.15, letterSpacing: '0.02em' }}>
                    Contáctenos.
                    <br />
                    <em style={{ color: 'rgba(247,243,236,0.45)', fontStyle: 'italic' }}>Estamos aquí para ayudarle.</em>
                  </h2>
                </div>
                <p style={{ color: 'rgba(247,243,236,0.45)', fontSize: '13px', lineHeight: 1.85, maxWidth: '380px', fontFamily: 'Montserrat, sans-serif' }}>
                  Estamos aquí para ayudarle a recuperar su propiedad. Contáctenos por cualquiera de estos medios.
                </p>

                {/* Contact details */}
                <div className="flex flex-col gap-5">
                  {/* Address */}
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center" style={{ border: '1px solid rgba(196,180,154,0.25)', color: '#C4B49A' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
                      </svg>
                    </div>
                    <div>
                      <p style={{ color: '#F7F3EC', fontSize: '13px', fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}>Dirección</p>
                      <p style={{ color: 'rgba(196,180,154,0.65)', fontSize: '12px', marginTop: '2px', fontFamily: 'Montserrat, sans-serif', lineHeight: 1.6 }}>Carrer Aragó, 24 Llevant<br />07006 Palma, Illes Balears</p>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center" style={{ border: '1px solid rgba(196,180,154,0.25)', color: '#C4B49A' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                      </svg>
                    </div>
                    <div>
                      <p style={{ color: '#F7F3EC', fontSize: '13px', fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}>Teléfono</p>
                      <a href="tel:+34634941415" style={{ color: 'rgba(196,180,154,0.65)', fontSize: '12px', marginTop: '2px', fontFamily: 'Montserrat, sans-serif', display: 'block' }}>634 94 14 15</a>
                      <a href="tel:+34971079369" style={{ color: 'rgba(196,180,154,0.65)', fontSize: '12px', fontFamily: 'Montserrat, sans-serif', display: 'block' }}>Fijo: 971 079 369</a>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center" style={{ border: '1px solid rgba(196,180,154,0.25)', color: '#C4B49A' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                      </svg>
                    </div>
                    <div>
                      <p style={{ color: '#F7F3EC', fontSize: '13px', fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}>Correo</p>
                      <a href="mailto:Info@gestraantiokupa.com" style={{ color: 'rgba(196,180,154,0.65)', fontSize: '12px', marginTop: '2px', fontFamily: 'Montserrat, sans-serif' }}>Info@gestraantiokupa.com</a>
                    </div>
                  </div>

                  {/* Hours */}
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center" style={{ border: '1px solid rgba(196,180,154,0.25)', color: '#C4B49A' }}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-4 h-4">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <p style={{ color: '#F7F3EC', fontSize: '13px', fontFamily: 'Montserrat, sans-serif', fontWeight: 500 }}>Horarios</p>
                      <p style={{ color: 'rgba(196,180,154,0.65)', fontSize: '12px', marginTop: '2px', fontFamily: 'Montserrat, sans-serif', lineHeight: 1.7 }}>
                        Lunes – Viernes<br />
                        9:30 – 13:30 · 16:00 – 18:30<br />
                        <span style={{ color: 'rgba(196,180,154,0.4)' }}>Sábado y Domingo: Cerrado</span>
                      </p>
                    </div>
                  </div>

                  {/* Social links */}
                  <div className="flex items-center gap-3 pt-2">
                    {[
                      {
                        href: 'https://wa.me/34634941415',
                        label: 'WhatsApp',
                        icon: (
                          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                          </svg>
                        ),
                      },
                      {
                        href: 'https://www.instagram.com/gestra_antiokupa',
                        label: 'Instagram',
                        icon: (
                          <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.057-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                          </svg>
                        ),
                      },
                    ].map((item, i) => (
                      <a
                        key={i}
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={item.label}
                        className="w-10 h-10 flex items-center justify-center transition-all duration-200"
                        style={{ border: '1px solid rgba(196,180,154,0.25)', color: '#C4B49A' }}
                        onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#C4B49A'; (e.currentTarget as HTMLElement).style.background = 'rgba(196,180,154,0.1)'; }}
                        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(196,180,154,0.25)'; (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
                      >
                        {item.icon}
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right — Form */}
              <div className="p-10" style={{ background: 'rgba(18,14,10,0.82)', border: '1px solid rgba(196,180,154,0.18)' }}>
                <h3 className="mb-8" style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.6rem', fontWeight: 400, color: '#F7F3EC', letterSpacing: '0.03em' }}>
                  Solicitar evaluación gratuita
                </h3>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}
